import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../../../00-MAIN/00-CONTEXT/AuthContext";

import InformationsGenerales from "./INFORMATIONS/InformationsGenerales";
import ChangePasswordForm from "./PASSWORD/ChangePasswordForm";
import PlanSubscription from "./PLAN-SOUSCRIPTION/PlanSubscription";

const USER_BACKEND_API_BASE_URL = process.env.REACT_APP_USER_BACKEND_API_URL;

export default function AccountPage() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);
  const [form, setForm] = useState({ prenom: "", nom: "", email: "", telephone: "" });
  const [activeTab, setActiveTab] = useState("general");
  const [saving, setSaving] = useState(false);
  const [hasChanged, setHasChanged] = useState(false);

  const token = localStorage.getItem("access_token");

  useEffect(() => {
    if (token) {
      axios
        .get(`${USER_BACKEND_API_BASE_URL}/users/me`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          setProfile(res.data);
          setForm({
            prenom: res.data.prenom || "",
            nom: res.data.nom || "",
            email: res.data.email || "",
            telephone: res.data.telephone || "",
          });
        })
        .catch(() => alert("Erreur de chargement du profil"));
    }
  }, [token]);

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
    setHasChanged(true);
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await axios.put(
        `${USER_BACKEND_API_BASE_URL}/users/me`,
        { ...form },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success("Profil mis à jour avec succès ✅");
      setHasChanged(false);
    } catch (err) {
      console.error(err);
      toast.error("Erreur lors de la mise à jour du profil ❌");
    } finally {
      setSaving(false);
    }
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "general":
        return (
          <InformationsGenerales
            form={form}
            handleChange={handleChange}
            handleSave={handleSave}
            saving={saving}
            hasChanged={hasChanged}
          />
        );
      case "security":
        return <ChangePasswordForm />;
      case "subscription":
        return <PlanSubscription />;
      default:
        return null;
    }
  };

  return (
    <div className="flex min-h-screen bg-[#FAFAFA]">
      <aside className="w-[260px] border-r border-gray-200 py-6 px-4">
        <h1 className="text-sm font-semibold mb-4 text-gray-700">Paramètres de votre compte</h1>
        <nav className="flex flex-col gap-2 text-sm">
          <TabButton label="Informations générales" activeTab={activeTab} setActiveTab={setActiveTab} value="general" />
          <TabButton label="Sécurité" activeTab={activeTab} setActiveTab={setActiveTab} value="security" />
          <TabButton label="Plan de souscription" activeTab={activeTab} setActiveTab={setActiveTab} value="subscription" />
        </nav>
      </aside>

      <main className="flex-1 flex justify-center py-12 px-8">
        <div className="w-full max-w-3xl">{renderTabContent()}</div>
      </main>
    </div>
  );
}

function TabButton({ label, activeTab, setActiveTab, value }) {
  const isActive = activeTab === value;
  return (
    <button
      onClick={() => setActiveTab(value)}
      className={`text-left px-2 py-1 rounded ${isActive
        ? "bg-[#E6F2EF] text-[#1D7C6E] font-medium"
        : "text-gray-700 hover:bg-gray-100"
        }`}
    >
      {label}
    </button>
  );
}
